export default __webpack_public_path__ + "static/media/auth-bg.8ac93f8c.png";